import { apiFetch, MOBILE_API } from "./api";

interface SignInResponse {
  success: boolean;
  token: string;
  message?: string;
}

interface BuyerLookupResponse {
  success: boolean;
  data?: {
    user?: { id: number; phoneNumber: string; name?: string };
    addresses?: unknown[];
  };
}

export async function buyerSignIn(phoneNumber: string) {
  return apiFetch<SignInResponse>(`${MOBILE_API}/auth/sign-in`, {
    method: "POST",
    body: { phoneNumber, signupMethod: "phone" },
  });
}

/**
 * Resolve the exact phone number format already stored in DB, so an existing
 * buyer signs into their existing account instead of creating a duplicate.
 * Falls back to the bare 10-digit format for new sign-ups (the mobile app's
 * format) — never to +91.
 */
async function resolveStoredPhone(phone10: string): Promise<string> {
  const candidates = [phone10, `+91${phone10}`];
  for (const candidate of candidates) {
    try {
      const res = await apiFetch<BuyerLookupResponse>(
        `${MOBILE_API}/users/mobile/${encodeURIComponent(candidate)}`
      );
      if (res.success && res.data?.user?.phoneNumber) {
        return res.data.user.phoneNumber;
      }
    } catch {
      // not found with this format, try next
    }
  }
  return phone10;
}

export async function buyerLogin(phone10: string): Promise<SignInResponse> {
  const storedPhone = await resolveStoredPhone(phone10);
  return buyerSignIn(storedPhone);
}
